/**
 * Site-wide values for www.travolabs.com, used by all three sections (the Travo Labs root, /travo
 * and /membersheep). No imports, so scripts/check-locale.ts can load it in plain Node.
 */

export const SITE_URL = 'https://www.travolabs.com';

/** The Travo Labs page, as its canonical URL spells it (with the slash). */
export const ROOT_URL = `${SITE_URL}/`;

export const SUPPORT_EMAIL = 'support@travolabs.com';

/** Seller on the App Store and the party in the privacy policies and terms. Fill in before release. */
export const LEGAL_NAME = '[Your legal name]';

/** Rendered by each section's catch-all route; prerendered to 404.html per section and locale. Not linked anywhere. */
export const NOT_FOUND_PATH = '/404';

/** JSON-LD ids of the two apps, shared by every page that mentions them. */
export const APP_IDS = {
  travo: `${SITE_URL}/travo#app`,
  memberSheep: `${SITE_URL}/membersheep#app`
} as const;
